import { extensions } from '../../extensions/Extensions.mjs';
import { NineSliceSpritePipe } from './NineSliceSpritePipe.mjs';

"use strict";
extensions.add(NineSliceSpritePipe);
//# sourceMappingURL=init.mjs.map
